import Service from "../Service";
const resource = "TicEquipmentAccessory/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
      params: { requestID: requestID },
    });
  },
  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID },
    });
  },
  listDevicesHistory(parameters, requestID) {
    return Service.post(resource + "history", parameters, {
      params: { requestID },
    });
  },
  SaveHistoryAccessory(parameters, requestID) {
    return Service.post(resource + "SaveHistoryAccessory", parameters, {
      params: { requestID },
    });
  },
};
